const seerBase = { v: 12 };
const articleLicensingEventConfigs = {
  pageOneSubmit: {
    event: 'article_license_page_one_submit',
    name: 'Article License Page One Submit',
    nl_subscribe: false,
    ...seerBase,
  },
  paymentSubmit: {
    event: 'article_license_payment_submit',
    name: 'Article License Payment Submit',
    article_license_cost: 650,
    licensed_newspost_purchase_id: '',
    ...seerBase,
  },
};

export default articleLicensingEventConfigs;
